/*
 * Copyright Camunda Services GmbH and/or licensed to Camunda Services GmbH under
 * one or more contributor license agreements. See the NOTICE file distributed
 * with this work for additional information regarding copyright ownership.
 * Licensed under the Camunda License 1.0. You may not use this file
 * except in compliance with the Camunda License 1.0.
 */

import DOMPurify from 'dompurify';

export function sanitizeWithSandboxedIframes(html) {
  const sandboxHook = (node, data) => {
    if (data.tagName?.toLowerCase() === 'iframe') {
      node.setAttribute('sandbox', 'allow-scripts allow-same-origin');
    }
  };

  DOMPurify.addHook('uponSanitizeElement', sandboxHook);

  const clean = DOMPurify.sanitize(html, {
    ADD_TAGS: ['iframe'],
    ADD_ATTR: ['allowfullscreen', 'sandbox']
  });

  DOMPurify.removeHook('uponSanitizeElement', sandboxHook);

  return clean;
}
